import {RootState} from "../../types";

export const isLoggedIn = (state: RootState) => state.auth.isLoggedIn;

export const isLoginModalOpen = (state: RootState) => state.auth.loginModalOpen;